export default "__VITE_ASSET__DqdI1pxQ__"